import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import EditInformation from "../components/EditInformation";
import {
  fetchIndustries,
  fetchCompanySizes
} from "../../../../actions/dropdowns.actions";
import {
  searchCompanies,
  fetchCompanies,
  createCompany
} from "../../../../actions/company.actions";
import { updateCompany } from "../../../../actions/company.actions";
import { searchCitiesAutocomplete } from "../../../../actions/cities.actions";
import { editEmployerProfile } from "../../../../actions/user.actions";

class EditInformationContainer extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.props.fetchIndustries();
    this.props.fetchCompanies();
    this.props.fetchCompanySizes();
  }

  handleSubmit(data) {
    if (data.location && _.isArray(data.location) && data.location.length > 0) {
      data.location = data.location[0].description
        ? data.location[0].description
        : data.location[0];
    }

    const payload = {
      user: {
        first_name: data.first_name,
        last_name: data.last_name,
        email: data.email,
        password: data.password,
        company_id: _.get(this.props.user, "profile.company.id")
      },
      company: {
        companyId: _.get(this.props.user, "profile.company.id"),
        name: data.company,
        industry_id: data.industry_id,
        company_size_id: data.company_size_id,
        location: data.location,
        url: data.url,
        summary: data.summary
      }
    };

    this.props.editEmployerProfile(payload);
  }

  render() {
    return (
      <EditInformation
        onSubmit={this.handleSubmit}
        industries={this.props.industries}
        companies={this.props.companies}
        companySizes={this.props.companySizes}
        companyName={this.props.match.params.companyName}
        cities={this.props.cities}
        onSearchCities={this.props.searchCitiesAutocomplete}
        onSearchCompanies={this.props.searchCompanies}
        createCompany={this.props.createCompany}
        isLoadingCompany={this.props.isLoadingCompany}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    industries: state.dropdowns.industries.data,
    companySizes: state.dropdowns.companySizes.data,
    cities: state.cities.cities.predictions,
    isLoading: state.cities.cities.isLoading,
    companies: state.company.companies.data,
    isLoadingCompany: state.company.isLoading,
    user: state.user.data
  };
};

const mapDispatchToProps = dispatch => ({
  editEmployerProfile: user => dispatch(editEmployerProfile(user)),
  fetchIndustries: () => dispatch(fetchIndustries()),
  fetchCompanySizes: () => dispatch(fetchCompanySizes()),
  updateCompany: company => dispatch(updateCompany(company)),
  searchCitiesAutocomplete: query => dispatch(searchCitiesAutocomplete(query)),
  fetchCompanies: () => dispatch(fetchCompanies()),
  createCompany: company => dispatch(createCompany(company)),
  searchCompanies: query => dispatch(searchCompanies(query))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditInformationContainer);



// WEBPACK FOOTER //
// ./src/routes/employer/editInformation/containers/EditInformationContainer.js